module.exports = __webpack_public_path__ + "img/menu-light.8b148949.svg";